export default "__VITE_ASSET__DVE69Uci__"